import { supabase } from '../lib/supabase';

export const adminUserRepository = {
  async fetchActivity(profileId: string): Promise<unknown> {
    const { data, error } = await supabase.rpc('admin_fetch_user_activity', {
      p_profile_id: profileId,
    });

    if (error) throw error;
    return data;
  },

  async fetchCreditBalance(profileId: string): Promise<unknown> {
    const { data, error } = await supabase.rpc('admin_get_credit_balance', {
      p_user_id: profileId,
    });

    if (error) throw error;
    return data;
  },
};
